'use strict';
const Tooltip = require('common/ui/view/behavior/tooltip');
const DiagramItemViewTemplate = require('system/ui/template/diagram/item.hbs');
const Marked = require('balus/util/marked');
const Mn = require('backbone.marionette');
require('backbone.stickit');
require('jquery-ui/ui/widgets/draggable');
require('jquery');

const ProjectRepository = require('common/domain/repository/project');
const CommentsCounterView = require('communication/ui/comment/view/counter');
const TasksCounterView = require('communication/ui/view/task/counter');
const i18next = require('i18next');
const AppInfoRepository = require('common/domain/repository/app-info');

module.exports = Mn.View.extend({
    showItemLink: true,
    tagName: 'li',
    className: function() {
        if(this.getOption('diagram') == this.model) {
            return 'list-item is-active';
        } else {
            return 'list-item'
        }
    },
    template: DiagramItemViewTemplate,
    modelEvents: {
        'change': 'render'
    },
    events: {
        'click .list-item-header-title .push-state': 'open'
    },
    regions: {
        commentsCounter: '.comments-counter',
        tasksCounter: '.tasks-counter',
    },
    behaviors: [Tooltip],

    initialize: function(options) {
        this._isMember = options.isMember;
    },

    serializeData: function() {
        var j = this.model.toJSON();
        if (j.updated_by && _.isEmpty(j.updated_by)) {
            delete j.updated_by;
        }
        j.type_i18n_key = this.model.i18nkey('type');
        j.url = this.model.path();
        j.isMember = this._isMember;

        if(this.isShowDescription()) {
            const desc = j.description ? j.description : i18next.t('balus_template_body_diagram:nav.no-description');
            j.description = Marked()(desc);
            j.showDescription = true;
        }

        return j;
    },

    onRender: function() {
        this.showItemLink = this.getOption('showItemLink');
        if(!this.showItemLink) {
            this.$('.list-item-header-title a')
                .click(function () {
                    return false;
                });
        }
    },

    onAttach: function() {
        const oldContext = this.getOption('context');
        const projectID = oldContext.projectId.toString();

        AppInfoRepository.get().then(appInfo => {
            const disabledProjectIDs = {
                "balus-local": {
                    "4997452146933760": "テスト"
                },
                "balus-dev": {
                    "5181915644559360": "モデル一覧のカウンター非表示のプロジェクト"
                },
                "balus-app": {
                    "5996769412382720": "SSSRC > SSSUP2019"
                }
            };
            const projectIDs = _.keys(disabledProjectIDs[appInfo.getAppID()] || {});
            const communicationCounterDisabled = _.contains(projectIDs, projectID);

            if (! communicationCounterDisabled) {
                this.onAttachCommunicationCounter();
            }
        });
    },

    onAttachCommunicationCounter: function() {
        const oldContext = this.getOption('context');

        ProjectRepository.getProject(oldContext.projectId)
            .then(project => {
                this.showChildView('commentsCounter', new CommentsCounterView({
                    icon: 'fa fa-comments-o',
                    project: project,
                    key: this.model.key,
                    hasComment: this.model.hasComment(),
                }));

                this.showChildView('tasksCounter', new TasksCounterView({
                    icon: 'fa fa-check-square',
                    project: project,
                    key: this.model.key,
                    hasTask: this.model.hasTask(),
                }));
            });
    },

    onDomRefresh: function() {
        if(this.isShowDescription()) {
            this.$('.diagram-list-item-description').readmore({
                moreLink: `<a href="#" style="font-weight: normal">${i18next.t('readmore.more')}</a>`,
                lessLink: `<a href="#" style="font-weight: normal">${i18next.t('readmore.less')}</a>`
            });
        }
    },

    open: function () {
        // ダイアグラム閲覧イベントをトラッキングするならば、ここに仕込む
    },

    isShowDescription: function() {
        return this.getOption('diagram') == this.model &&
            this.getOption('showDescription');
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram/item.js